"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9020],{

/***/ 75594:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://mn.chatie.me/assets/1e87e304b842775497d75b6a6e4acd64eac080c3/_next/static/media/chatie_origin_logo.64143023.png","height":104,"width":394,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEUbHygdISkfHycdISnlgDOpqFd+cX04Oy8AMET9X13zAAAACXRSTlNHYS86PFEuNBoqOWTTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVQImWNgYeNgYmZmYGJgYWVnYGRgZAAAAhwALz4ZvGUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 47944:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://mn.chatie.me/assets/1e87e304b842775497d75b6a6e4acd64eac080c3/_next/static/media/cheming_logo.09809e82.png","height":66,"width":180,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAIVBMVEWNJOmHF+6NHuyFC/KCBvaIFu+KHOuDDvKGFu6BCPNMaXGnOPqkAAAAC3RSTlNJkRc8ZnEsV7N4AFK66toAAAAJcEhZcwAAITgAACE4AUWWMWAAAAAiSURBVAiZBcGJAQAgDAKxA/qo+w9swvTLrVoS75EEbQ/wAQYVAFprCzPxAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 7436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_HomeHeader; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/image.js
var next_image = __webpack_require__(26410);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var esm = __webpack_require__(9150);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-6d39449242/0/cache/chatie-design-system-https-edc3b42f07-dc9424d6a3.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(82740);
// EXTERNAL MODULE: ./public/icons/chatie_origin_logo.png
var chatie_origin_logo = __webpack_require__(75594);
;// CONCATENATED MODULE: ./public/icons/cheming/ic_cheming_store.svg
var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _path8, _path9, _path10, _path11, _path12, _g6, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIcChemingStore = function SvgIcChemingStore(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M24 0H0v24h24z"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "ic_cheming_store_svg__a",
    width: 7,
    height: 4,
    x: 0,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M.889 7.38h5.333v3.111H.89v-3.11Z"
  }))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    mask: "url(#ic_cheming_store_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#B266FF",
    fillRule: "evenodd",
    d: "M6.222 7.38A3.111 3.111 0 1 1 0 7.38h6.222",
    clipRule: "evenodd"
  }))), /*#__PURE__*/react.createElement("mask", {
    id: "ic_cheming_store_svg__b",
    width: 7,
    height: 4,
    x: 6,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M6.222 7.38h6.222v3.111H6.222v-3.11"
  }))), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    mask: "url(#ic_cheming_store_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12.444 7.38a3.11 3.11 0 1 1-6.222 0h6.222",
    clipRule: "evenodd"
  }))), /*#__PURE__*/react.createElement("mask", {
    id: "ic_cheming_store_svg__c",
    width: 7,
    height: 4,
    x: 11,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M11.556 7.38h6.222v3.111h-6.222v-3.11"
  }))), _g3 || (_g3 = /*#__PURE__*/react.createElement("g", {
    mask: "url(#ic_cheming_store_svg__c)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#B266FF",
    fillRule: "evenodd",
    d: "M17.778 7.38a3.111 3.111 0 1 1-6.222 0h6.222",
    clipRule: "evenodd"
  }))), /*#__PURE__*/react.createElement("mask", {
    id: "ic_cheming_store_svg__d",
    width: 7,
    height: 4,
    x: 17,
    y: 7,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M17.778 7.38h5.333v3.111h-5.333v-3.11"
  }))), _g4 || (_g4 = /*#__PURE__*/react.createElement("g", {
    mask: "url(#ic_cheming_store_svg__d)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24 7.38a3.111 3.111 0 1 1-6.222 0H24",
    clipRule: "evenodd"
  }))), /*#__PURE__*/react.createElement("mask", {
    id: "ic_cheming_store_svg__e",
    width: 24,
    height: 7,
    x: 0,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 2.058h23.906v6H0v-6"
  }))), _g5 || (_g5 = /*#__PURE__*/react.createElement("g", {
    mask: "url(#ic_cheming_store_svg__e)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#B266FF",
    d: "M3.729 2.481.535 7.751h22.841l-3.301-5.27H3.729Z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M7.536 2.644 6.397 7.752h5.29V2.644H7.537ZM16.663 2.653l1.128 5.019h5.604l-3.366-5.02h-3.366"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M1.218 7.193h21.46l-2.753-4.27H3.915l-2.697 4.27m22.255.865H.432a.433.433 0 0 1-.365-.664L3.31 2.26a.433.433 0 0 1 .366-.201H20.16c.147 0 .284.074.364.198l3.295 5.11a.433.433 0 0 1-.347.691",
    clipRule: "evenodd"
  }))), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.323 10.982A3.327 3.327 0 0 1 0 7.66a.433.433 0 1 1 .865 0 2.46 2.46 0 0 0 2.458 2.458 2.46 2.46 0 0 0 2.458-2.458.433.433 0 1 1 .866 0 3.327 3.327 0 0 1-3.324 3.323",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.105 10.982A3.327 3.327 0 0 1 5.78 7.66a.433.433 0 1 1 .866 0 2.46 2.46 0 0 0 2.458 2.458 2.46 2.46 0 0 0 2.458-2.458.433.433 0 0 1 .865 0 3.327 3.327 0 0 1-3.323 3.323",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.886 10.982a3.327 3.327 0 0 1-3.323-3.323.433.433 0 1 1 .865 0 2.46 2.46 0 0 0 2.458 2.458 2.46 2.46 0 0 0 2.458-2.458.433.433 0 1 1 .866 0 3.327 3.327 0 0 1-3.324 3.323",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.668 10.982a3.327 3.327 0 0 1-3.324-3.323.433.433 0 1 1 .866 0 2.46 2.46 0 0 0 2.458 2.458 2.46 2.46 0 0 0 2.458-2.458.433.433 0 1 1 .865 0 3.327 3.327 0 0 1-3.323 3.323",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.053 21.351H2.109a.433.433 0 0 1-.433-.433V10.282a.433.433 0 1 1 .865 0v10.204h19.08V10.282a.433.433 0 1 1 .865 0v10.636c0 .24-.194.433-.433.433",
    clipRule: "evenodd"
  })), /*#__PURE__*/react.createElement("mask", {
    id: "ic_cheming_store_svg__f",
    width: 24,
    height: 20,
    x: 0,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 21.351h23.991V2.058H0V21.35"
  }))), _g6 || (_g6 = /*#__PURE__*/react.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#ic_cheming_store_svg__f)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M4.294 18.459h9.168v-5.824H4.294v5.824m9.6.865H3.862a.433.433 0 0 1-.432-.433v-6.688c0-.24.193-.433.432-.433h10.034c.239 0 .432.194.432.433v6.689a.433.433 0 0 1-.432.432M16.1 20.486h3.645v-7.85h-3.644v7.85m4.078.865h-4.51a.433.433 0 0 1-.433-.433v-8.715c0-.24.194-.433.433-.433h4.51c.239 0 .433.194.433.433v8.715a.433.433 0 0 1-.433.433"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.178 19.324h-4.51a.433.433 0 1 1 0-.865h4.51a.433.433 0 1 1 0 .865M22.914 21.351H1.125a.433.433 0 1 1 0-.865h21.79a.433.433 0 1 1 0 .865"
  }))), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M.822 7.198H23.08l-2.975-4.614H3.736L.822 7.198m22.796.584H.292a.292.292 0 0 1-.247-.447l3.283-5.199A.292.292 0 0 1 3.575 2h16.69c.1 0 .192.05.246.134l3.339 5.179a.291.291 0 0 1-.232.47",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ var ic_cheming_store = (SvgIcChemingStore);
;// CONCATENATED MODULE: ./public/icons/cheming/ic_cheming_stroke_face.svg
var _circle, ic_cheming_stroke_face_path;
function ic_cheming_stroke_face_extends() { ic_cheming_stroke_face_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_cheming_stroke_face_extends.apply(this, arguments); }

var SvgIcChemingStrokeFace = function SvgIcChemingStrokeFace(props) {
  return /*#__PURE__*/react.createElement("svg", ic_cheming_stroke_face_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#E5CCFF",
    stroke: "#000",
    strokeWidth: 0.8
  })), ic_cheming_stroke_face_path || (ic_cheming_stroke_face_path = /*#__PURE__*/react.createElement("path", {
    fill: "#444",
    fillRule: "evenodd",
    d: "M7.72 8.63a.557.557 0 0 1 1.06 0c.074.23.288.385.53.385.54 0 .763.69.327 1.008a.557.557 0 0 0-.202.623.557.557 0 0 1-.858.623.557.557 0 0 0-.654 0 .557.557 0 0 1-.858-.623.557.557 0 0 0-.202-.623.557.557 0 0 1 .327-1.008.557.557 0 0 0 .53-.384m-.636 3.71a.5.5 0 0 0-.584.494 5.5 5.5 0 1 0 11 0 .5.5 0 0 0-.584-.493l-.008.001-.024.004-.094.015a46.913 46.913 0 0 1-1.571.226c-.984.125-2.21.247-3.219.247-1.01 0-2.235-.122-3.219-.247a46.916 46.916 0 0 1-1.571-.226l-.094-.015-.024-.004-.008-.001m9.378 1.085c-.297.045-.683.1-1.118.155-.995.125-2.27.254-3.344.254-1.074 0-2.349-.129-3.344-.254-.435-.055-.82-.11-1.117-.155a4.5 4.5 0 0 0 8.923 0m-.182-4.794a.557.557 0 0 0-1.06 0 .557.557 0 0 1-.53.384c-.54 0-.763.69-.327 1.008a.557.557 0 0 1 .202.623c-.166.513.421.94.858.623a.557.557 0 0 1 .654 0 .557.557 0 0 0 .858-.623.557.557 0 0 1 .202-.623.557.557 0 0 0-.328-1.008.557.557 0 0 1-.53-.384",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ var ic_cheming_stroke_face = (SvgIcChemingStrokeFace);
;// CONCATENATED MODULE: ./public/icons/header/ic_freeballoons.svg
var ic_freeballoons_g, _defs;
function ic_freeballoons_extends() { ic_freeballoons_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_freeballoons_extends.apply(this, arguments); }

var SvgIcFreeballoons = function SvgIcFreeballoons(props) {
  return /*#__PURE__*/react.createElement("svg", ic_freeballoons_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 35,
    fill: "none"
  }, props), ic_freeballoons_g || (ic_freeballoons_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#ic_freeballoons_svg__a)"
  }, /*#__PURE__*/react.createElement("g", {
    filter: "url(#ic_freeballoons_svg__b)"
  }, /*#__PURE__*/react.createElement("mask", {
    id: "ic_freeballoons_svg__d",
    width: 99,
    height: 28,
    x: 3.465,
    y: 1.938,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M3.465 1.938h99v28h-99z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M6.678 15.505c0-5.836 4.731-10.567 10.567-10.567h71.652c5.837 0 10.568 4.731 10.568 10.567 0 5.837-4.731 10.568-10.568 10.568H17.245c-5.836 0-10.567-4.731-10.567-10.568"
  })), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.9,
    d: "M6.678 15.505c0-5.836 4.731-10.567 10.567-10.567h71.652c5.837 0 10.568 4.731 10.568 10.567 0 5.837-4.731 10.568-10.568 10.568H17.245c-5.836 0-10.567-4.731-10.567-10.568"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "url(#ic_freeballoons_svg__c)",
    d: "M17.245 1.938h71.652v6H17.245v-6Zm71.652 27.135H17.245v-6h71.652v6m-71.652 0c-7.493 0-13.567-6.074-13.567-13.568h6a7.568 7.568 0 0 0 7.567 7.568v6m85.22-13.568c0 7.493-6.075 13.568-13.568 13.568v-6a7.568 7.568 0 0 0 7.568-7.568h6M88.897 1.938c7.493 0 13.568 6.074 13.568 13.567h-6a7.568 7.568 0 0 0-7.568-7.567v-6m-71.652 6a7.568 7.568 0 0 0-7.567 7.567h-6c0-7.493 6.074-13.567 13.567-13.567v6",
    mask: "url(#ic_freeballoons_svg__d)"
  })), /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M4.4 15.5a.6.6 0 1 1 1.2 0zm96 0a.6.6 0 0 1 1.2 0zm1.2 0a.6.6 0 0 1-1.2 0zm-96 0a.6.6 0 1 1-1.2 0zm11.9 11.4a.6.6 0 1 1 0 1.2zm7 1.2a.6.6 0 1 1 0-1.2zm1-1.2a.6.6 0 1 1 0 1.2zm7 1.2a.6.6 0 1 1 0-1.2zm1-1.2a.6.6 0 1 1 0 1.2zm7 1.2a.6.6 0 1 1 0-1.2zm1-1.2a.6.6 0 1 1 0 1.2zm7 1.2a.6.6 0 1 1 0-1.2zm1-1.2a.6.6 0 1 1 0 1.2zm7 1.2a.6.6 0 1 1 0-1.2zm1-1.2a.6.6 0 1 1 0 1.2zm7 1.2a.6.6 0 1 1 0-1.2zm1-1.2a.6.6 0 1 1 0 1.2zm7 1.2a.6.6 0 1 1 0-1.2zm1-1.2a.6.6 0 1 1 0 1.2zm7 1.2a.6.6 0 1 1 0-1.2zm1-1.2a.6.6 0 1 1 0 1.2zm7 1.2a.6.6 0 1 1 0-1.2zm1.06-1.213a.6.6 0 1 1 .058 1.198l-.058-1.198m7.902-2.051a.6.6 0 0 1-.806-.889l.806.889m-.015-1.68a.6.6 0 0 1 .889.806l-.889-.806m4.138-7.038a.6.6 0 1 1-1.199-.058zm-1.199-1.178a.6.6 0 0 1 1.199-.058l-1.199.058m-2.05-7.902a.6.6 0 1 1-.889.806l.889-.806m-1.68.015a.6.6 0 0 1 .806-.889l-.806.889m-7.038-4.138a.6.6 0 1 1-.058 1.199l.058-1.2ZM88.5 4.1a.6.6 0 1 1 0-1.2zm-7-1.2a.6.6 0 1 1 0 1.2zm-1 1.2a.6.6 0 1 1 0-1.2zm-7-1.2a.6.6 0 1 1 0 1.2zm-1 1.2a.6.6 0 1 1 0-1.2zm-7-1.2a.6.6 0 1 1 0 1.2zm-1 1.2a.6.6 0 1 1 0-1.2zm-7-1.2a.6.6 0 1 1 0 1.2zm-1 1.2a.6.6 0 1 1 0-1.2zm-7-1.2a.6.6 0 1 1 0 1.2zm-1 1.2a.6.6 0 1 1 0-1.2zm-7-1.2a.6.6 0 1 1 0 1.2zm-1 1.2a.6.6 0 1 1 0-1.2zm-7-1.2a.6.6 0 1 1 0 1.2zm-1 1.2a.6.6 0 1 1 0-1.2zm-7-1.2a.6.6 0 1 1 0 1.2zm-1 1.2a.6.6 0 1 1 0-1.2zm-7-1.2a.6.6 0 1 1 0 1.2zm-1.06 1.214a.6.6 0 1 1-.058-1.2l.058 1.2m-7.902 2.05a.6.6 0 1 1 .806.889l-.806-.889m.015 1.68a.6.6 0 1 1-.889-.806l.889.806m-4.138 7.038a.6.6 0 1 1 1.199.058l-1.2-.058m1.199 1.178a.6.6 0 1 1-1.2.058l1.2-.058m2.05 7.902a.6.6 0 0 1 .889-.806l-.889.806m1.68-.015a.6.6 0 1 1-.806.889l.806-.889m7.038 4.138a.6.6 0 0 1 .058-1.198l-.058 1.198M17 26.9h.5v1.2H17zm7.5 0h1v1.2h-1zm8 0h1v1.2h-1zm8 0h1v1.2h-1zm8 0h1v1.2h-1zm8 0h1v1.2h-1zm8 0h1v1.2h-1zm8 0h1v1.2h-1zm8 0h1v1.2h-1zm8 0h.5v1.2h-.5zm.5 0c.188 0 .375-.005.56-.013l.058 1.198c-.205.01-.41.015-.618.015zm7.656-2.953c.276-.25.54-.515.791-.791l.889.806c-.277.305-.569.597-.874.874l-.806-.889m3.73-7.887c.009-.185.014-.372.014-.56h1.2c0 .207-.005.413-.015.618l-1.199-.058m.014-.56c0-.188-.005-.375-.014-.56l1.199-.058c.01.205.015.41.015.618zm-2.953-7.656c-.25-.276-.515-.54-.791-.791l.806-.889c.305.277.597.569.874.874l-.889.806m-7.887-3.73A11.598 11.598 0 0 0 89 4.1V2.9c.207 0 .413.005.618.015l-.058 1.199M89 4.1h-.5V2.9h.5zm-7.5 0h-1V2.9h1zm-8 0h-1V2.9h1zm-8 0h-1V2.9h1zm-8 0h-1V2.9h1zm-8 0h-1V2.9h1zm-8 0h-1V2.9h1zm-8 0h-1V2.9h1zm-8 0h-1V2.9h1zm-8 0H17V2.9h.5zm-.5 0c-.188 0-.375.005-.56.014l-.058-1.2c.205-.009.41-.014.618-.014zM9.344 7.053c-.276.25-.54.515-.791.791l-.889-.806c.277-.305.569-.597.874-.874l.806.889m-3.73 7.887a11.61 11.61 0 0 0-.014.56H4.4c0-.207.005-.413.015-.618l1.199.058m-.014.56c0 .188.005.375.014.56l-1.2.058A12.81 12.81 0 0 1 4.4 15.5zm2.953 7.656c.25.276.515.54.791.791l-.806.889a12.684 12.684 0 0 1-.874-.874l.889-.806m7.887 3.73c.185.01.372.014.56.014v1.2c-.207 0-.413-.005-.618-.015l.058-1.198"
  }), /*#__PURE__*/react.createElement("path", {
    stroke: "#ACB0B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M91.245 10.8 82.8 19.244M91.245 19.245 82.8 10.8"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#1D2129",
    d: "M23.886 9.899v4.68h-7.8v-4.68h7.8M20.714 21.04h-1.521v-3.848h-4.446v-1.209h10.465v1.209h-4.498v3.848m1.664-7.67v-2.262h-4.771v2.262h4.77m13.094 3.198h-1.677v1.807h2.665v1.209H25.995v-1.209h2.639v-1.807h-1.3v-3.835h6.292v-1.339h-6.357v-1.209h7.865v3.757h-6.292v1.404h6.63zm-5.356 0v1.807h2.21v-1.807z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#EF4239",
    d: "M50.512 21.027h-1.456v-5.811H48.03v5.278H46.6V9.652h1.43v4.355h1.027V9.444h1.456v11.583m-7.995-3.991c1.183.039 2.574-.065 3.354-.26l.143 1.196c-.87.234-2.574.312-3.913.312h-1.105v-7.462h4.381v1.209c-.949 0-1.898-.013-2.86-.013v5.018m15.681-1.755c0 .962-.78 1.664-1.937 1.898v.754c1.027-.065 1.95-.13 2.64-.221.038.377.064.78.116 1.157-1.092.156-2.73.299-3.913.364-.923.039-1.95.078-3.08.078l-.209-1.261c.962 0 1.95 0 2.912-.039v-.819c-1.209-.195-2.04-.923-2.04-1.911 0-1.157 1.17-1.95 2.755-1.95 1.6 0 2.756.793 2.756 1.95m2.86-5.837v4.732h1.495v1.248h-1.495v5.603H59.55V9.444h1.508m-2.314 3.523H52.14V11.81h6.604v1.157m-4.9-1.651v-1.17h3.275v1.17h-3.276m2.846 3.965c0-.442-.52-.793-1.248-.793-.715 0-1.222.351-1.222.793 0 .429.507.806 1.222.806.728 0 1.248-.377 1.248-.806m11.34 2.145h-1.522v-2.379a81.837 81.837 0 0 1-3.302.065 40.786 40.786 0 0 1-.208-1.235c1.6 0 3.315-.039 4.784-.117.17-.611.273-1.417.273-2.418h-3.939v-1.196h5.46c0 1.521-.117 2.6-.325 3.51.533-.039.975-.078 1.352-.117l.182 1.144c-.819.117-1.78.208-2.756.286v2.457m1.052-.806v-1.04h2.327V9.444h1.521v8.827h-1.52V16.62h-2.328m4.03 4.095H64.61V17.14h1.521v2.366h6.981v1.209m2.07-3.835-.208-6.669h1.69l-.182 6.669h-1.3m-.13 2.769v-1.521h1.56v1.521h-1.56"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "ic_freeballoons_svg__c",
    x1: 131.047,
    x2: 121.485,
    y1: 14.78,
    y2: 52.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#FFB21B"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#EF4239"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "ic_freeballoons_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h106v35H0z"
  })), /*#__PURE__*/react.createElement("filter", {
    id: "ic_freeballoons_svg__b",
    width: 104.787,
    height: 33.135,
    x: 0.678,
    y: 0.938,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/react.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/react.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/react.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_650_1813"
  }), /*#__PURE__*/react.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_650_1813",
    result: "shape"
  })))));
};
/* harmony default export */ var ic_freeballoons = (SvgIcFreeballoons);
;// CONCATENATED MODULE: ./public/icons/ic_roulette.svg
var ic_roulette_path, ic_roulette_defs, ic_roulette_circle, _circle2, _circle3, ic_roulette_path2, ic_roulette_path3, ic_roulette_path4, ic_roulette_path5, ic_roulette_path6, ic_roulette_path7, ic_roulette_path8, _circle4;
function ic_roulette_extends() { ic_roulette_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_roulette_extends.apply(this, arguments); }

var SvgIcRoulette = function SvgIcRoulette(props) {
  return /*#__PURE__*/react.createElement("svg", ic_roulette_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), ic_roulette_path || (ic_roulette_path = /*#__PURE__*/react.createElement("path", {
    fill: "#FF6B6B",
    d: "m12 1-1.8 3h3.6Z"
  })), ic_roulette_defs || (ic_roulette_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "ic_roulette_svg__a",
    x1: 3,
    x2: 21,
    y1: 4,
    y2: 22
  }, /*#__PURE__*/react.createElement("stop", {
    offset: "0%",
    stopColor: "#A78BFA"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: "100%",
    stopColor: "#60A5FA"
  })))), ic_roulette_circle || (ic_roulette_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 9,
    stroke: "url(#ic_roulette_svg__a)",
    strokeWidth: 1.8
  })), _circle2 || (_circle2 = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3,
    fill: "#A78BFA",
    opacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 3,
    stroke: "#A78BFA",
    strokeWidth: 1.5
  })), ic_roulette_path2 || (ic_roulette_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#A78BFA",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M12 4v6"
  })), ic_roulette_path3 || (ic_roulette_path3 = /*#__PURE__*/react.createElement("path", {
    stroke: "#60A5FA",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M12 16v6"
  })), ic_roulette_path4 || (ic_roulette_path4 = /*#__PURE__*/react.createElement("path", {
    stroke: "#F472B6",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M3 13h6"
  })), ic_roulette_path5 || (ic_roulette_path5 = /*#__PURE__*/react.createElement("path", {
    stroke: "#34D399",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M15 13h6"
  })), ic_roulette_path6 || (ic_roulette_path6 = /*#__PURE__*/react.createElement("path", {
    stroke: "#FBBF24",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "m5.64 6.64 4.24 4.24M14.12 15.12l4.24 4.24"
  })), ic_roulette_path7 || (ic_roulette_path7 = /*#__PURE__*/react.createElement("path", {
    stroke: "#F472B6",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "m18.36 6.64-4.24 4.24"
  })), ic_roulette_path8 || (ic_roulette_path8 = /*#__PURE__*/react.createElement("path", {
    stroke: "#34D399",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "m9.88 15.12-4.24 4.24"
  })), _circle4 || (_circle4 = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 1.2,
    fill: "#A78BFA"
  })));
};
/* harmony default export */ var ic_roulette = (SvgIcRoulette);
;// CONCATENATED MODULE: ./public/icons/play_iso_logo.png
/* harmony default export */ var play_iso_logo = ({"src":"https://mn.chatie.me/assets/1e87e304b842775497d75b6a6e4acd64eac080c3/_next/static/media/play_iso_logo.487d9a2c.png","height":104,"width":158,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAATlBMVEVDWts4ecksprJEWNwWmaxRgtQ4hsUUkq5Ae85LZttXad8xdcdWZOENarlWedkwkbyvwexOZtydxOJEoMF2ieQwqLRwpdZPrcKDqd4+jcXGWoi6AAAAEnRSTlMYAg+dY/XvPhmLB0H5PetU/ufVGBXgAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVQImQXBBwKAIAwAsWO2KKAs0f9/1AQ9i4iIJYXnG3t53Lzf3ocn5VZDjBcHgKr5ASl9Aai7wvFAAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/icons/stroke-face.svg
var stroke_face_circle, stroke_face_path;
function stroke_face_extends() { stroke_face_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stroke_face_extends.apply(this, arguments); }

var SvgStrokeFace = function SvgStrokeFace(props) {
  return /*#__PURE__*/react.createElement("svg", stroke_face_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), stroke_face_circle || (stroke_face_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#A6DADF",
    stroke: "#000",
    strokeWidth: 0.8
  })), stroke_face_path || (stroke_face_path = /*#__PURE__*/react.createElement("path", {
    fill: "#444",
    fillRule: "evenodd",
    d: "M7.72 8.63a.557.557 0 0 1 1.06 0c.074.23.288.385.53.385.54 0 .763.69.327 1.008a.557.557 0 0 0-.202.623.557.557 0 0 1-.858.623.557.557 0 0 0-.654 0 .557.557 0 0 1-.858-.623.557.557 0 0 0-.202-.623.557.557 0 0 1 .327-1.008.557.557 0 0 0 .53-.384m-.636 3.71a.5.5 0 0 0-.584.494 5.5 5.5 0 1 0 11 0 .5.5 0 0 0-.584-.493l-.008.001-.024.004-.094.015a46.913 46.913 0 0 1-1.571.226c-.984.125-2.21.247-3.219.247-1.01 0-2.235-.122-3.219-.247a46.916 46.916 0 0 1-1.571-.226l-.094-.015-.024-.004-.008-.001m9.378 1.085c-.297.045-.683.1-1.118.155-.995.125-2.27.254-3.344.254-1.074 0-2.349-.129-3.344-.254-.435-.055-.82-.11-1.117-.155a4.5 4.5 0 0 0 8.923 0m-.182-4.794a.557.557 0 0 0-1.06 0 .557.557 0 0 1-.53.384c-.54 0-.763.69-.327 1.008a.557.557 0 0 1 .202.623c-.166.513.421.94.858.623a.557.557 0 0 1 .654 0 .557.557 0 0 0 .858-.623.557.557 0 0 1 .202-.623.557.557 0 0 0-.328-1.008.557.557 0 0 1-.53-.384",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ var stroke_face = (SvgStrokeFace);
// EXTERNAL MODULE: ./public/images/cheming/cheming_logo.png
var cheming_logo = __webpack_require__(47944);
;// CONCATENATED MODULE: ./public/images/homeHeader/ic_free_balloon.svg
var ic_free_balloon_path, ic_free_balloon_path2, ic_free_balloon_path3, ic_free_balloon_path4, ic_free_balloon_path5, ic_free_balloon_path6, ic_free_balloon_path7, ic_free_balloon_path8, ic_free_balloon_path9, ic_free_balloon_path10;
function ic_free_balloon_extends() { ic_free_balloon_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_free_balloon_extends.apply(this, arguments); }

var SvgIcFreeBalloon = function SvgIcFreeBalloon(props) {
  return /*#__PURE__*/react.createElement("svg", ic_free_balloon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    fill: "none"
  }, props), ic_free_balloon_path || (ic_free_balloon_path = /*#__PURE__*/react.createElement("path", {
    fill: "#EF4239",
    fillRule: "evenodd",
    d: "M6.136 13.906s-1.348 1.62-.116 1.754h1.364s.824-.16.16-1.223l-.505-.531",
    clipRule: "evenodd"
  })), ic_free_balloon_path2 || (ic_free_balloon_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M6.136 13.906s-1.348 1.62-.116 1.754h1.364s.824-.16.16-1.223l-.505-.531"
  })), ic_free_balloon_path3 || (ic_free_balloon_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFB21C",
    fillRule: "evenodd",
    d: "M11.901 14.158s.2.638-.159 1.183c0 0-.567.69-1.204.186 0 0-1.22-.747-.369-1.278 0 0 .416-.303.91-.487",
    clipRule: "evenodd"
  })), ic_free_balloon_path4 || (ic_free_balloon_path4 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M11.901 14.158s.2.638-.159 1.183c0 0-.567.69-1.204.186 0 0-1.22-.747-.369-1.278 0 0 .416-.303.91-.487M6.652 15.66c.23.727.817 2.366 2.109 3.652 0 0 1.547 1.891.877 3.604"
  })), ic_free_balloon_path5 || (ic_free_balloon_path5 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M10.423 15.449s-2.089 1.806-1.345 4.356c0 0 .605 1.116-1.468 2.969"
  })), ic_free_balloon_path6 || (ic_free_balloon_path6 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M9.233 20.09s-2.528-1.86-3.152.233c0 0 .045 1.973 3.079-.08 0 0 1.253-3.574 2.582-1.734 0 0 .983 1.482-2.51 1.58",
    clipRule: "evenodd"
  })), ic_free_balloon_path7 || (ic_free_balloon_path7 = /*#__PURE__*/react.createElement("path", {
    fill: "#FFB21C",
    fillRule: "evenodd",
    d: "M10.403 5.293c1.194-1.251 2.878-1.841 4.495-1.4 2.482.68 3.864 3.536 3.086 6.38-.778 2.845-3.42 4.6-5.903 3.922-1.09-.299-1.968-1.017-2.544-1.97",
    clipRule: "evenodd"
  })), ic_free_balloon_path8 || (ic_free_balloon_path8 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M10.403 5.293c1.194-1.251 2.878-1.841 4.495-1.4 2.482.68 3.864 3.536 3.086 6.38-.778 2.845-3.42 4.6-5.903 3.922-1.09-.299-1.968-1.017-2.544-1.97"
  })), ic_free_balloon_path9 || (ic_free_balloon_path9 = /*#__PURE__*/react.createElement("path", {
    fill: "#EF4239",
    fillRule: "evenodd",
    d: "M10.673 6.658c.364 3.399-1.384 6.819-4.042 7.104-2.659.285-5.221-2.673-5.585-6.071C.68 4.293 2.54 1.307 5.199 1.022c2.659-.285 5.11 2.238 5.474 5.636",
    clipRule: "evenodd"
  })), ic_free_balloon_path10 || (ic_free_balloon_path10 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M10.673 6.658c.364 3.399-1.384 6.819-4.042 7.104-2.659.285-5.221-2.673-5.585-6.071C.68 4.293 2.54 1.307 5.199 1.022c2.659-.285 5.11 2.238 5.474 5.636",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ var ic_free_balloon = (SvgIcFreeBalloon);
;// CONCATENATED MODULE: ./public/images/homeHeader/ic_notice.svg
var ic_notice_path, ic_notice_path2, ic_notice_path3, ic_notice_path4;
function ic_notice_extends() { ic_notice_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ic_notice_extends.apply(this, arguments); }

var SvgIcNotice = function SvgIcNotice(props) {
  return /*#__PURE__*/react.createElement("svg", ic_notice_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), ic_notice_path || (ic_notice_path = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M4.102 10.171S4.102 4 11 4c0 0 6.813 0 6.813 6.171v6.974c0 .438.096.87.281 1.267L19 20.355H3l.855-1.975a3 3 0 0 0 .247-1.192V10.17M12.43 20.474a1.72 1.72 0 1 1-2.616-.007h2.6l.016.007",
    clipRule: "evenodd"
  })), ic_notice_path2 || (ic_notice_path2 = /*#__PURE__*/react.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M11.12 1v3"
  })), ic_notice_path3 || (ic_notice_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#EF4239",
    d: "M22.833 7a5.833 5.833 0 1 0-11.666 0 5.833 5.833 0 0 0 11.666 0"
  })), ic_notice_path4 || (ic_notice_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m18.09 7.591-1.6-2.733a5.366 5.366 0 0 0-.287-.449 1.268 1.268 0 0 0-.256-.271.68.68 0 0 0-.29-.141 1.508 1.508 0 0 0-.3-.027c-.28 0-.518.048-.667.183l-.003.003c-.145.138-.195.362-.195.624v4.722c0 .18.065.335.212.437l.003.001.002.002c.127.08.271.12.428.12.156 0 .3-.04.427-.12l.003-.002.002-.001a.503.503 0 0 0 .213-.437V6.167c.041.08.085.161.132.241l1.6 2.734c.107.185.203.335.286.448.083.114.168.208.254.278l.002.002.003.002a.73.73 0 0 0 .287.13c.09.02.192.028.3.028.279 0 .516-.048.66-.185.152-.138.206-.363.206-.626V4.497c0-.178-.064-.333-.215-.43a.746.746 0 0 0-.43-.13.746.746 0 0 0-.43.13c-.15.097-.215.252-.215.43v3.335a5.681 5.681 0 0 0-.133-.24",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ var ic_notice = (SvgIcNotice);
// EXTERNAL MODULE: ./constants/index.ts + 3 modules
var constants = __webpack_require__(39819);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/localStorage.ts
var localStorage = __webpack_require__(48163);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
// EXTERNAL MODULE: ./components/common/SvgIcon.tsx
var SvgIcon = __webpack_require__(34368);
// EXTERNAL MODULE: ./components/common/Tab.tsx
var Tab = __webpack_require__(93127);
;// CONCATENATED MODULE: ./components/common/HomeHeader.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    width: 100%;\n    ",
        ";\n    padding-top: 10px;\n    position: fixed;\n    z-index: 98;\n    top: 0;\n\n    .home-header {\n      display: flex;\n      align-items: center;\n      max-width: inherit;\n      top: 0;\n      z-index: 9;\n      width: 100%;\n      background-color: ",
        ";\n      justify-content: space-between;\n      padding: ",
        "px;\n      height: 9%;\n      padding-left: 14px;\n\n      ",
        "\n    }\n    .logo-container {\n      width: 164px;\n      height: 25px;\n\n      img {\n        transition: filter 0.2s ease;\n        ",
        "\n      }\n    }\n\n    .free_message_badge {\n      position: absolute !important;\n      padding: 5px;\n      bottom: 13px;\n      left: auto;\n      right: 44px;\n\n      z-index: 100;\n    }\n\n    .has-sidebar & {\n      ",
        " {\n        border-left: 1px solid ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n  color: ",
        ";\n\n  i svg [stroke='black'],\n  i svg [stroke='#000'],\n  i svg [stroke='#000000'] {\n    stroke: ",
        ";\n  }\n  i svg [fill='#444444'],\n  i svg [fill='#444'] {\n    fill: ",
        ";\n  }\n  i svg [fill='#A6DADF'] {\n    fill: ",
        ";\n  }\n  .balloon-icon i svg [fill='#EF4239'] {\n    fill: ",
        ";\n  }\n  .balloon-icon i svg [fill='#FFB21C'] {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


























var headerWrapperCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.var.white, css/* responsiveMaxWidth */.S8, theme.var.white, esm/* Spacing.medium */.Ki.medium, (0,css/* safeArea */.BI)("top", "margin"), theme.var.white !== "#ffffff" ? "filter: brightness(0) invert(1);" : "", css/* media.tablet */.BC.tablet, theme.var.gray200);
};
var iconsCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject1(), esm/* Spacing.medium */.Ki.medium, theme.var.black, theme.var.black, theme.var.gray800, theme.name === "dark" ? theme.var.gray300 : "#A6DADF", theme.name === "dark" ? theme.var.gray500 : "#EF4239", theme.name === "dark" ? theme.var.gray400 : "#FFB21C");
};
var iconButtonStyle = {
    cursor: "pointer",
    fontSize: 18,
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 24,
    height: 24,
    background: "none",
    border: "none",
    padding: 0
};
var HomeHeader = function(param) {
    var hasNewNotification = param.hasNewNotification, tabs = param.tabs, lastPeekTabViewDate = param.lastPeekTabViewDate, _isHome = param.isHome, isHome = _isHome === void 0 ? false : _isHome;
    var router = (0,next_router.useRouter)();
    var isProduction = "production" === "production";
    var isStagingOrDev =  false || "production" === "dev";
    var ref = (0,global/* useGlobalContext */.bN)(), platform = ref.platform, version = ref.version, isCheming = ref.isCheming;
    var firebase = (0,analytics/* useAnalytics */.z$)().firebase;
    var web = (0,webview/* useWebView */.B9)().web;
    var ref1 = (0,react.useState)(false), isShowFreeMessageBadge = ref1[0], setIsShowFreeMessageBadge = ref1[1];
    var handleRouting = function(path) {
        if (path === "/payment") {
            if (platform === constants/* Platform.web */.t4.web) {
                router.push(path);
            }
            if ((0,misc/* checkRequiredAppVersion */._h)(platform, version, {
                iOS: "2.26.1",
                android: "2.32.4"
            })) {
                return web.openPage("/payment");
            } else {
                return (0,misc/* openDeepLink */.Hu)("chatie-app://payment", router);
            }
        }
        if (platform === constants/* Platform.web */.t4.web) {
            router.push(path);
        } else {
            web.openPage(path);
        }
    };
    var handleClickBadge = function() {
        var currentDate = new Date().getTime();
        localStorage/* ParsedStorage.setItem */.f.setItem("freeMessageBadgeClosedDate", currentDate);
        setIsShowFreeMessageBadge(false);
        return;
    };
    var handleClickEventPage = function() {
        firebase.logEvent("event_page_click", {});
        handleRouting("/events");
    };
    (0,react.useEffect)(function() {
        var targetDate = new Date("2024-11-01").getTime();
        var currentTime = new Date().getTime();
        if (currentTime > targetDate) {
            setIsShowFreeMessageBadge(false);
            return;
        }
        var storedDate = localStorage/* ParsedStorage.getItem */.f.getItem("freeMessageBadgeClosedDate");
        if (storedDate) {
            var currentTime1 = new Date().getTime();
            var timeDifference = currentTime1 - storedDate;
            var oneDayInMilliseconds = 24 * 60 * 60 * 1000;
            if (timeDifference < oneDayInMilliseconds) {
                setIsShowFreeMessageBadge(false);
                return;
            }
        }
        setIsShowFreeMessageBadge(true);
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: headerWrapperCSS,
        suppressHydrationWarning: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("header", {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    className: "home-header",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: "logo-container",
                            children: isCheming ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((image_default()), {
                                src: cheming_logo/* default */.Z,
                                loading: "eager",
                                objectFit: "cover",
                                width: 60,
                                height: 22,
                                alt: "logo",
                                unoptimized: true
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((image_default()), {
                                        src: chatie_origin_logo/* default */.Z,
                                        loader: function(param) {
                                            var src = param.src;
                                            return src;
                                        },
                                        loading: "eager",
                                        objectFit: "cover",
                                        width: 120,
                                        height: 25,
                                        alt: "logo"
                                    }),
                                    !isHome && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((image_default()), {
                                        src: play_iso_logo,
                                        loading: "eager",
                                        objectFit: "cover",
                                        width: 40,
                                        height: 25,
                                        alt: "logo",
                                        unoptimized: true
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                            css: iconsCSS,
                            children: [
                                !isProduction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    onClick: function() {
                                        return handleRouting("/millie-test");
                                    },
                                    className: "face-container",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                        icon: icon/* Heart */.YK
                                    })
                                }),
                                isStagingOrDev && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                    onClick: function() {
                                        return handleRouting("/cutscene-verify");
                                    },
                                    title: "컷씬 검증 (staging \xb7 dev)",
                                    type: "button",
                                    style: iconButtonStyle,
                                    "aria-label": "cutscene-verify",
                                    children: "\uD83C\uDFAC"
                                }),
                                isCheming ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            onClick: function() {
                                                return handleRouting("/search");
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                                icon: icon/* Search */.HN
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            onClick: handleClickEventPage,
                                            className: "face-container",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                                icon: ic_cheming_stroke_face
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            onClick: function() {
                                                return handleRouting("/payment");
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                                icon: ic_cheming_store
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                    children: [
                                        !isHome && constants/* COMMUNITY_FEATURE_ENABLED */.vj && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            type: "button",
                                            style: iconButtonStyle,
                                            "aria-label": "사용자 대화방",
                                            title: "사용자 대화방",
                                            onClick: function() {
                                                return handleRouting("/conversations");
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("svg", {
                                                "aria-hidden": "true",
                                                width: "22",
                                                height: "22",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("path", {
                                                    d: "M4 5.5h16v11H9l-5 3v-14Z",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinejoin: "round"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            onClick: function() {
                                                return handleRouting("/search");
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                                icon: icon/* Search */.HN
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            onClick: handleClickEventPage,
                                            className: "face-container",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                                icon: stroke_face
                                            })
                                        }),
                                         true && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            onClick: function() {
                                                return handleRouting("/roulette");
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                                icon: ic_roulette
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            onClick: function() {
                                                return handleRouting("/payment");
                                            },
                                            className: "balloon-icon",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                                icon: ic_free_balloon
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                            onClick: function() {
                                                return handleRouting("/notifications");
                                            },
                                            children: hasNewNotification ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                                icon: ic_notice
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                                icon: icon/* Bell */.Uo
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        isShowFreeMessageBadge && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: "free_message_badge",
                            onClick: handleClickBadge,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SvgIcon/* default */.Z, {
                                icon: ic_freeballoons
                            })
                        })
                    ]
                }),
                !isCheming && tabs && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Tab/* default */.Z, _objectSpreadProps(_objectSpread({}, tabs), {
                    fit: true,
                    lastPeekTabViewDate: lastPeekTabViewDate
                }))
            ]
        })
    });
};
/* harmony default export */ var common_HomeHeader = (HomeHeader);


/***/ }),

/***/ 85496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ cdnLoader; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8683);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26410);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_0__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


function cdnLoader(param) {
    var src = param.src, width = param.width;
    return "".concat(src, "?w=").concat(width);
}
var Image = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_0___default()), _objectSpreadProps(_objectSpread({}, props), {
        loader: cdnLoader
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 59585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WB": function() { return /* binding */ modalCSS; },
/* harmony export */   "b$": function() { return /* binding */ contentCSS; },
/* harmony export */   "mH": function() { return /* binding */ ModalButton; }
/* harmony export */ });
/* unused harmony export RefModal */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var _stores_useOverlayStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46092);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9150);
/* harmony import */ var _components_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38945);
/* harmony import */ var _components_common_Overlay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38632);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96964);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n  ",
        "\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n          transform: scale(1);\n          visibility: visible;\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n          transition: 0.25s;\n          transform: scale(0.4);\n          opacity: 0;\n          visibility: hidden;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    border-radius: ",
        "px;\n    background-color: ",
        ";\n    color: ",
        ";\n    width: 100%;\n    max-width: 480px;\n    max-height: 100%;\n    margin: 0 auto;\n    transition: 0.3s;\n    will-change: transform;\n    overflow-x: hidden;\n\n    ",
        "\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    justify-content: space-between;\n    padding: 0 ",
        "px;\n    height: ",
        "px;\n\n    background-color: ",
        ";\n    border-bottom: ",
        ";\n\n    h4 {\n      text-align: center;\n      line-height: ",
        "px;\n    }\n\n    button {\n      position: absolute;\n      top: 10px;\n      right: ",
        "px;\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: auto;\n  padding: ",
        "px;\n  padding-top: ",
        "px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        "px;\n\n  & + & {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}








var modalWrapCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .safeArea */ .BI)("top", "padding", 16), (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium));
var modalCSS = function(isOpen) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject3(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Radius.large */ .wU.large, theme.overlay.bg, theme.var.black, isOpen ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject1()) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject2()));
    };
};
var headerCSS = function(hideHeaderBorder) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject4(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_HEADER_HEIGHT */ .PV, theme.overlay.bg, hideHeaderBorder ? "0" : "1px solid ".concat(theme.border.light), _styles_css__WEBPACK_IMPORTED_MODULE_5__/* .MODAL_HEADER_HEIGHT */ .PV, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.small */ .Ki.small);
    };
};
var contentCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject5(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xlarge */ .Ki.xlarge);
var Modal = function(_param) {
    var title = _param.title, children = _param.children, _hideCloseButton = _param.hideCloseButton, hideCloseButton = _hideCloseButton === void 0 ? false : _hideCloseButton, _hideHeaderBorder = _param.hideHeaderBorder, hideHeaderBorder = _hideHeaderBorder === void 0 ? false : _hideHeaderBorder, _header = _param.header, header = _header === void 0 ? true : _header, props = _objectWithoutProperties(_param, [
        "title",
        "children",
        "hideCloseButton",
        "hideHeaderBorder",
        "header"
    ]);
    var open = props.open, ref = props.ref;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_common_Overlay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({
        css: modalWrapCSS
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
            css: modalCSS(open),
            className: "modal-container",
            ref: ref,
            children: [
                header && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("header", {
                    css: headerCSS(hideHeaderBorder),
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h4", {
                            children: title
                        }),
                        !hideCloseButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_common_Overlay__WEBPACK_IMPORTED_MODULE_4__/* .OverlayClose */ .G, _objectSpread({}, props))
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
                    css: contentCSS,
                    children: children
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (Modal);
/** Button */ var modalButtonCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.css)(_templateObject6(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xlarge */ .Ki.xlarge, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium);
var ModalButton = function(_param) {
    var onClick = _param.onClick, className = _param.className, props = _objectWithoutProperties(_param, [
        "onClick",
        "className"
    ]);
    var closeOverlay = (0,_stores_useOverlayStore__WEBPACK_IMPORTED_MODULE_1__/* .useCloseOverlay */ .E)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        css: modalButtonCSS,
        suppressHydrationWarning: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({
            className: className
        }, props), {
            onClick: onClick !== null && onClick !== void 0 ? onClick : function() {
                return closeOverlay();
            }
        }))
    });
};
var RefModal = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref // forwardRef로 전달된 ref
) {
    var title = _param.title, children = _param.children, _hideCloseButton = _param.hideCloseButton, hideCloseButton = _hideCloseButton === void 0 ? false : _hideCloseButton, _hideHeaderBorder = _param.hideHeaderBorder, hideHeaderBorder = _hideHeaderBorder === void 0 ? false : _hideHeaderBorder, _header = _param.header, header = _header === void 0 ? true : _header, props = _objectWithoutProperties(_param, [
        "title",
        "children",
        "hideCloseButton",
        "hideHeaderBorder",
        "header"
    ]);
    var open = props.open;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_common_Overlay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpreadProps(_objectSpread({
        css: modalWrapCSS
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
            css: modalCSS(open),
            className: "modal-container",
            ref: ref,
            children: [
                header && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("header", {
                    css: headerCSS(hideHeaderBorder),
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h4", {
                            children: title
                        }),
                        !hideCloseButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_common_Overlay__WEBPACK_IMPORTED_MODULE_4__/* .OverlayClose */ .G, _objectSpread({}, props))
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
                    css: contentCSS,
                    children: children
                })
            ]
        })
    }));
});
RefModal.displayName = "RefModal";


/***/ }),

/***/ 66806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ PlayHeaderContainer; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var _components_common_HomeHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7436);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97033);




var HomeHeaderContainer = function(param) {
    var tabs = param.tabs;
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_2__/* .useMe */ .Pi)(), me = ref.data;
    var hasNotification = !!(me === null || me === void 0 ? void 0 : me.hasNewNotification);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_common_HomeHeader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        hasNewNotification: hasNotification,
        tabs: tabs,
        isHome: true
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeHeaderContainer);
var PlayHeaderContainer = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(function PlayHeaderContainer(param) {
    var tabs = param.tabs, lastPeekTabViewDate = param.lastPeekTabViewDate;
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_2__/* .useMe */ .Pi)(), me = ref.data;
    var hasNotification = !!(me === null || me === void 0 ? void 0 : me.hasNewNotification);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_common_HomeHeader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        hasNewNotification: hasNotification,
        tabs: tabs,
        lastPeekTabViewDate: lastPeekTabViewDate
    });
});


/***/ }),

/***/ 4223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var _CharacterSkeleton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48782);
/* harmony import */ var _SituationSkeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68877);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .character {\n    padding: 0 ",
        "px;\n  }\n\n  .situation {\n    display: flex;\n    width: 100%;\n    overflow: hidden;\n    padding: 0 ",
        "px;\n    gap: ",
        "px;\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var loadingCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.small */ .Ki.small);
var PlaySkeleton = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        css: loadingCSS,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: "character",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_CharacterSkeleton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
                className: "situation",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_SituationSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_SituationSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_SituationSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_SituationSkeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PlaySkeleton);


/***/ })

}]);